import { API_BASE_URL } from "../config/api";

export const categoryTypeService = {
  getAllCategoryTypes: async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categorytypes/allcategorytypes`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Category type service error:", error);
      throw error;
    }
  },

  addCategoryType: async (typeData) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categorytypes/addcategorytype`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(typeData),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to add category type");
      }
      return response.json();
    } catch (error) {
      console.error("Category type service error:", error);
      throw error;
    }
  },

  deleteCategoryType: async (id) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categorytypes/deletecategorytype/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to delete category type");
      }
      return response.json();
    } catch (error) {
      console.error("Category type service error:", error);
      throw error;
    }
  },
};
